import { useParams } from "react-router-dom";
import { ThemeProvider } from "../theme/ThemeProvider";
import { BookingFlow } from "../flow/BookingFlow";
import { useSession } from "../store/sessionStore";
import styles from "./BookRoute.module.css";

/**
 * Standalone branded page wrapper for /book/:garageId. Same <BookingFlow/> as
 * the embed, but inside a light branded shell with a header and footer.
 */
export function BookRoute() {
  const { garageId = "" } = useParams();
  const config = useSession((s) => s.config);

  return (
    <ThemeProvider theme={config?.theme}>
      <div className={styles.page}>
        <header className={styles.header}>
          <div className={styles.headerInner}>
            <a className={styles.wordmark} href="#top">
              {config?.theme.logoUrl ? (
                <img src={config.theme.logoUrl} alt={config.name} className={styles.logo} />
              ) : (
                <>
                  <span className={styles.name}>{config?.name ?? "Autopic"}</span>
                  <span className={styles.by}>Booking</span>
                </>
              )}
            </a>
            {config && config.branches[0]?.phone && (
              <a className={styles.phone} href={`tel:${config.branches[0].phone}`}>
                {config.branches[0].phone}
              </a>
            )}
          </div>
        </header>

        <main className={styles.main} id="top">
          <BookingFlow garageId={garageId} />
        </main>

        <footer className={styles.footer}>
          <div className={styles.footerInner}>
            <p>
              {config?.name ?? "Autopic"} · Online booking powered by{" "}
              <strong>Autopic</strong>
            </p>
            <p className={styles.footMuted}>
              Vehicle data via DVLA/DVSA. No payment is taken online.
            </p>
          </div>
        </footer>
      </div>
    </ThemeProvider>
  );
}
